import { Endpoint } from '../../endpoint';

export const downloadPdfFile = (fileName: string, text: string) => {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = Endpoint.DOWNLOAD_PDF_FILE;
  form.style.cssText = 'display:none;';
  document.body.appendChild(form);

  const formField = document.createElement('input');
  formField.type = 'text';
  formField.name = 'file_name_dp1';
  formField.value = fileName;

  form.appendChild(formField);

  const formField2 = document.createElement('textarea');
  formField2.name = 'text_dp1';
  formField2.value = text;

  form.appendChild(formField2);

  form.submit();
};
